module.exports = __webpack_public_path__ + "d48ba7351e4c57c5d19ca2cb2f4df012.png";